/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ModeloBodega from 'Infotrack@Modelos/smartStock/bodegas';
import ModeloDivision from 'Infotrack@Modelos/smartStock/bodegasDivisiones'
import ModeloClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones';
import ModeloFamilia from 'Infotrack@Modelos/smartStock/familias';

export default class EntidadesFiltroInvenitarioCM {
  private modeloClasificaciones: ModeloClasificaciones;
  private modeloFamilia: ModeloFamilia;
  private modeloBodega: ModeloBodega;
  private modeloDivision: ModeloDivision;

  constructor() {
    this.modeloClasificaciones = new ModeloClasificaciones();
    this.modeloFamilia = new ModeloFamilia();
    this.modeloBodega = new ModeloBodega();
    this.modeloDivision = new ModeloDivision();
  }

  public consultaEntidadesFiltro(EmpresaId: string, IdUsuario: string) {
    return Promise.all([
      this.modeloClasificaciones.consultarListaClasificacionesPorFiltro({ EmpresaId }),
      this.modeloFamilia.consultarListaFamiliasPorFiltro({ EmpresaId }),
      this.modeloBodega.consultarListaBodegasFiltro({ EmpresaId, IdUsuario })
    ]).then((entidades) => ({
      clasificaciones: entidades[0].data.Entidades,
      familias: entidades[1].data.Entidades,
      bodegas: entidades[2].data.Entidades,
    }));
  }

  public cosultaDivisionesPorBodegaId(BodegaId: number, EmpresaId: string) {
    return this.modeloDivision.consultarDivisionesFiltro({ BodegaId, EmpresaId }).then(({ data: { Entidades } }) => Entidades);
  }
}
